import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-partners-openforge-services-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './partners-openforge-services-section.component.html',
  styleUrl: './partners-openforge-services-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersOpenforgeServicesSectionComponent {}
